import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    name: "bEDate",
})
export class BEDatePipe implements PipeTransform {
  transform(date: Date | string, format = "dd/MM/yyyy"): string {
    date = new Date(date); // if orginal type was a string
    date.setFullYear(date.getFullYear() + 543);
    return new DatePipe("en-US").transform(date, format) as string;
  }
}
